import { returnAnio } from "../../utils/funciones";
import { errDigitosAnio } from "../../utils/Constants";
import moment from "moment";

export const useDatosPersonalesExtranjero = () => {
  const validateVisaFechas = (desde, hasta, errrObj) => {
    if (returnAnio(desde) < 1000) { errrObj.visaTemporariaDesde = errDigitosAnio; }
    if (returnAnio(hasta) < 1000) { errrObj.visaTemporariaHasta = errDigitosAnio; }

    const diferenciaDias = moment(new Date(hasta)).diff(moment(new Date(desde)), 'days');

    if (diferenciaDias < 1) { errrObj.visaTemporariaHasta = "La fecha de vencimiento debe ser mayor"; }
  }

  const validatePersonalesExtranjero = (obj) => {
    let errrObj = {};
    const { tipoVisa, visaTemporariaDesde, visaTemporariaHasta, nacionalidad } = obj;

    if (Number.parseInt(nacionalidad) !== 1 && !visaTemporariaDesde) { errrObj.visaTemporariaDesde = "Requerido"; }

  validateVisaFechas(visaTemporariaDesde, visaTemporariaHasta, errrObj);

    if (Number.parseInt(nacionalidad) !== 1 && !tipoVisa) { errrObj.tipoVisa = "Requerido"; }
    if (Number.parseInt(nacionalidad) !== 1 && !visaTemporariaHasta) { errrObj.visaTemporariaHasta = "Requerido"; }
    
    return errrObj;
  }

  return { validatePersonalesExtranjero }
}